const AuthStatus = {
  UNAUTH: 'unauthenticated',
  AUTH: 'authenticated',
};

// AuthStatus is default to satisfy eslint, remove the following once more types are added
export default AuthStatus;
